<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25.605"
    height="24"
    viewBox="0 0 25.605 24"
  >
    <g transform="translate(0 -0.678)">
      <g transform="translate(8.468 0.294)">
        <path
          class="a"
          d="M4.5,0,9,7H0Z"
          transform="translate(-0.166 0.384)"
          :fill="color"
        />
        <path
          class="a"
          d="M4.5,0,9,7H0Z"
          transform="translate(8.834 24.384) rotate(180)"
          :fill="color"
        />
      </g>
      <g transform="translate(0 16.776) rotate(-90)">
        <path
          class="a"
          d="M4.043,0,8.086,8.086H0Z"
          transform="translate(0)"
          :fill="color"
        />
        <path
          class="a"
          d="M4.043,0,8.086,8.086H0Z"
          transform="translate(8.086 25.605) rotate(180)"
          :fill="color"
        />
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'AppGuideIcon',
    props: {
      color: {
        type: String,
        default: '#383935',
      },
    },
  }
</script>

<style scoped>
  svg {
    width: 25.605px;
    height: 24px;
  }
</style>
